export default "__VITE_ASSET__0ab04829__"